import React, { forwardRef } from 'react';
import { Divider as MuiDivider } from '@material-ui/core';
import { useDsTokens } from '../theme/useDsTokens';
import { cn } from '../utils/cn';
import { DividerOrientation, DividerVariant, DsPrimitiveProps } from './types';

export interface DividerProps extends DsPrimitiveProps {
  orientation?: DividerOrientation;
  variant?: DividerVariant;
  /** When true, hides from accessibility tree */
  decorative?: boolean;
  marginY?: 'sm' | 'md';
}

export const Divider = forwardRef<HTMLHRElement, DividerProps>(function Divider(
  {
    id,
    className,
    orientation = 'horizontal',
    variant = 'default',
    decorative = false,
    marginY = 'sm',
    'data-testid': testId,
  },
  ref
) {
  const tokens = useDsTokens();
  const margin = marginY === 'md' ? tokens.space3 : tokens.space2;

  return (
    <MuiDivider
      ref={ref}
      id={id}
      className={cn(className)}
      data-testid={testId}
      orientation={orientation}
      role={decorative ? undefined : 'separator'}
      aria-hidden={decorative ? true : undefined}
      aria-orientation={decorative ? undefined : orientation}
      style={{
        backgroundColor: tokens.borderDefault,
        height: orientation === 'horizontal' ? tokens.borderWidthDefault : undefined,
        width: orientation === 'vertical' ? tokens.borderWidthDefault : undefined,
        marginTop: orientation === 'horizontal' ? margin : 0,
        marginBottom: orientation === 'horizontal' ? margin : 0,
        marginLeft: variant === 'inset' && orientation === 'horizontal' ? tokens.space3 : 0,
      }}
    />
  );
});

Divider.displayName = 'Divider';
